import * as React from 'react'

const SvgEventScheduleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.125 18.75a5 5 0 110-10 5 5 0 010 10zm0-8.75a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zm.994 5.625L12.5 14.006V11.25h1.25v2.244l1.25 1.25-.881.881zM17.5 3.75c0-.69-.56-1.25-1.25-1.25h-2.5V1.25H12.5V2.5h-5V1.25H6.25V2.5h-2.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h2.5v-1.25h-2.5V3.75h2.5V5H7.5V3.75h5V5h1.25V3.75h2.5V7.5h1.25V3.75z"
      fill="#163250"
    />
  </svg>
)

export default SvgEventScheduleIcon
